// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-rise -> dolben-rise -> woodview-at-randolph
// Generated: 2026-11-03T15:47:03.700Z
// Counts: 0 design, 63 content, 8 slot group, 1 collection binding, 6 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome home to your new apartment! Here at Woodview at Randolph, we pride ourselves in providing our residents with a <a class=\"richtext-link\" href=\"/neighborhood\">community</a> that takes comfort to the next level. With stunning features and <a class=\"richtext-link\" href=\"/amenities\">amenities</a>, a coveted location, and a variety of floor plans, living in Randolph, Massachusetts just got a whole lot better when you’re at Woodview at Randolph.</p><p>Convenience starts here at our apartment community. In addition to a swimming pool with a lifeguard, a BBQ picnic area, and disability access, our pet-friendly apartments have been updated to meet your every need. Depending on your selection of a studio, one-, or two-bedroom apartment, different features will be available to make your day-to-day life easier. Do you want wall-to-wall carpeting? Check! Do you prefer faux-granite countertops and air conditioning? We have them! Laundry facility? No worries there! Did we mention that you can make your payments online?</p><p>If you’re looking for an adventure, we’re conveniently located south of Boston. Take a few minutes to jump on the Fall River Expressway for a short drive to one of this country’s most historic cities. We’re also just minutes away from the MBTA Middleborough/Lakeville Line.</p><p>Coming home feels better at Woodview at Randolph. Our fabulous apartments and community have been filled with ample features, and no detail has been overlooked. Invest a moment of your time in return for what could be years of the best living experience you’ve ever known. We invite you to <a class=\"richtext-link\" href=\"/gallery\">view our photo gallery</a> to see a snapshot of what we offer.</p><p>Whether you’re looking for the perfect floor plan, a comfortable living experience, or a lot of amenities to help you relax, Woodview at Randolph has it all. Join us by becoming a part of our community so that you too can see how good life can be at our apartments in Randolph, MA.</p><p>Do you want to find a new and improved meaning to the term resident? <a class=\"richtext-link\" href=\"/contact-us\">Contact us</a> today to schedule a tour and find out more!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentcafe-chatbot.background_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Spaces and features designed for everyday living</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "betterbot-chatbot.embed_script": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_betterbot_script"
  },
  "callrail-tracking.account_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_account_hash"
  },
  "callrail-tracking.company_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_company_id"
  },
  "communityfilmembed.video": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/property/6737460151193209/01a1210f-00af-7083-b722-80ca9059b1af.m4v",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reach our leasing team — we're happy to help</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Let's Talk</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.opt_in_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "By submitting this form and signing up for texts, you consent to receive text messages (including review requests and/or surveys) about your experience at the phone number you provided. Message & data rates may apply. Message frequency varies. Unsubscribe at any time by replying STOP. Reply HELP for help.",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.opt_in_enabled": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.opt_in_required": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "contactinfocards.call_label": {
    "overrideType": "VALUE",
    "customValue": "<h3>CALL US</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactinfocards.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h3>OFFICE HOURS</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactinfocards.visit_label": {
    "overrideType": "VALUE",
    "customValue": "<h3>VISIT US</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find a layout that fits your life</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>A look inside our apartments and community</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Now Leasing</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "lifestyleintro.headline": {
    "overrideType": "VALUE",
    "customValue": "<h3>A LIFESTYLE DESIGNED FOR YOU</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover local favorites just around the corner</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhooddiscover.headline": {
    "overrideType": "VALUE",
    "customValue": "<h3>DISCOVER THE NEIGHBORHOOD</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.form.opt_in_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "By submitting this form and signing up for texts, you consent to receive text messages (including review requests and/or surveys) about your experience at the phone number you provided. Message & data rates may apply. Message frequency varies. Unsubscribe at any time by replying STOP. Reply HELP for help.",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.form.opt_in_enabled": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.form.opt_in_required": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience The Dolben Difference</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Experience <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<p>What People Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "terms-and-conditions-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Terms &amp; Conditions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore our homes from anywhere</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tours</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At our pet-friendly community, we pride ourselves in knowing that you can go through your day and then come home to relax. Enjoy exciting features like wall-to-wall carpeting, European-style white cabinetry, central air conditioning, spacious closets, and more. Or, head outside to additional options for comfort and relaxation; our fabulous community acts as an extension of your <a class=\"richtext-link\" href=\"/floor-plans\">apartment home</a>. Enjoy using our fitness center to help you stay physically active, unlimited parking to fulfill all of you and your guests' parking needs, and extra storage facilities.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "applyctabanner.headline": {
    "overrideType": "VALUE",
    "customValue": "<p>APARTMENT HOMES - AVAILABLE NOW</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanspopup.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a18954-0a5b-7223-856e-7dcac9fcecc2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Woodview at Randolph is <a class=\"richtext-link\" href=\"/floor-plans\">comfortable apartment living</a> at its finest, and you can see it for yourself by viewing our photo gallery. Take a moment to browse through our pet-friendly Randolph apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "incomerestrictedcontent.eligibility_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Eligibility for income-restricted apartments at Woodview at Randolph depends on your household size and gross annual household income. Income limits and maximum allowable rents are updated from time to time, so please <a href=\"/contact-us\">contact our leasing office</a> for the current figures before you apply. Housing Choice Voucher holders are welcome to apply, and households applying with a voucher do not have to meet a minimum income requirement.</p>",
    "mappedField": null
  },
  "incomerestrictedcontent.important_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Woodview at Randolph offers disability access, and some apartments may include accessibility features. Please ask our leasing team about the accommodations available to you.</p><p>Residents are responsible for any utilities not included in the rent, such as electricity, natural gas, and water/sewer, as well as phone, cable, and internet service, depending on the apartment.</p>",
    "mappedField": null
  },
  "incomerestrictedcontent.utilities_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Woodview at Randolph, residents pay usage-based charges for electricity, natural gas, and water/sewer. A utility allowance for these services, set by apartment type and housing program, is factored into the income-restricted rent calculation.</p>",
    "mappedField": null
  },
  "lifestyleintro.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">At our pet-friendly community, we pride ourselves in knowing that you can go through your day and then come home to relax. Enjoy exciting features like wall-to-wall carpeting, European-style white cabinetry, central air conditioning, spacious closets, and more. Or, head outside to additional options for comfort and relaxation; our fabulous community acts as an extension of your </span><a class=\"richtext-link\" href=\"/floor-plans\">apartment home</a><span style=\"font-size: 16px;\">. Enjoy using our fitness center to help you stay physically active, unlimited parking to fulfill all of you and your guests' parking needs, and extra storage facilities.</span></p>",
    "generatedValue": "<p>Your <a href=\"/amenities\">apartment-living experience</a> comes first at Woodview at Randolph. Inside your studio, one-, or two-bedroom home, you'll find faux granite countertops, European-style white cabinetry, Whirlpool appliances including a dishwasher, central air conditioning, and a private balcony or patio in select homes. Step outside and spend summer afternoons at our in-ground pool with a lifeguard, fire up the grill at the BBQ picnic area, or keep up your routine in the fitness center. Laundry facilities in every building, extra storage, and unlimited parking make everyday errands easy, and pets are welcome too. At our apartments in Randolph, MA, everything you need is right at home.</p>",
    "mappedField": null
  },
  "neighborhooddiscover.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": "<p>Life at Woodview at Randolph puts the best of Randolph, MA close to home. Pick up groceries at Shaw's, just 0.4 miles away, then grab dinner at Yamiyaki or a warm bowl at Pho 98°C down the road. When you want fresh air, walk your pup at Randolph Dog Park or spend an afternoon at Powers Farm Community Park, and save the weekends for the trails at Holbrook Town Forest. Commuting is simple too. The MBTA Middleborough/Lakeville Line and nearby highways get you to Boston quickly. Open our <a href=\"/interactive-map\">interactive map</a> to find your new favorite spots.</p>",
    "mappedField": "property_home_neighborhood_blurb"
  },
  "retailshops.intro": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Shopping &amp; Dining Near <a href=\"/neighborhood\">Woodview at Randolph</a></p>",
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Nothing helps you to imagine the possibilities for a <a class=\"richtext-link\" href=\"/floor-plans\">new apartment home</a> quite like a virtual tour. Take a look around - we know you'll love it here!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "contactinfocards.address": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_google_place_url"
      }
    }
  },
  "footer.address": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_google_place_url"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      }
    }
  },
  "hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Schedule Tour"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Search Apartments"
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a10ce5-ad3e-7008-a6a7-503e53a5e3bb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and umbrellas"
      }
    }
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "galleryslider.images": {
    "limit": 6,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "betterbot-chatbot",
      "blockId": "betterbot-chatbot",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
